import { create } from 'zustand'

type Lang = 'en' | 'zh' | 'bilingual'

interface LangState {
  lang: Lang
  setLang: (lang: Lang) => void
}

export const useLangStore = create<LangState>((set) => ({
  lang: (localStorage.getItem('hksi_lang') as Lang) || 'en',
  setLang: (lang) => {
    localStorage.setItem('hksi_lang', lang)
    set({ lang })
  },
}))
